// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__jumSO","icon":"Counter_icon__jMp+Q","disabled":"Counter_disabled__NB8s5","input":"Counter_input__Q08PQ"};